import { render, staticRenderFns } from "./DxDetailTab.vue?vue&type=template&id=afa3c046&"
import script from "./DxDetailTab.vue?vue&type=script&lang=js&"
export * from "./DxDetailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports